import PublicOutlinedIcon from '@material-ui/icons/PublicOutlined';
import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '../Tooltip';

const ORGANIZATION_SCOPED_FOLDER_ICON_LABEL = 'Organization managed folder';
const ORGANIZATION_SCOPED_FOLDER_TOOLTIP =
  'Documents in this folder are shared organization-wide';

const IconWrap = styled.span<{ $size: 'default' | 'large' }>`
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.gray666};

  svg {
    font-size: ${({ $size }) => ($size === 'large' ? '1.25rem' : '1rem')};
  }
`;

interface OrganizationScopedFolderIconProps {
  size?: 'default' | 'large';
}

export function OrganizationScopedFolderIcon({
  size = 'default',
}: OrganizationScopedFolderIconProps) {
  return (
    <Tooltip title={ORGANIZATION_SCOPED_FOLDER_TOOLTIP}>
      <IconWrap $size={size}>
        <PublicOutlinedIcon
          tabIndex={0}
          titleAccess={ORGANIZATION_SCOPED_FOLDER_ICON_LABEL}
        />
      </IconWrap>
    </Tooltip>
  );
}
